module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/cloudbeds.json
// module id = 719
// module chunks = 13554671377208